import React from 'react'

import { useDispatch } from 'customizer/hooks'
import { setMobileDescription } from 'customizer/questionPanel/actions'
import useThemeSettings from 'customizer/theme/useThemeSettings'
import CommonLabelAnswer, {
  LabelAnswerProps as CommonLabelAnswerProps,
} from 'themes/common/components/answers/LabelAnswer'
import ExtraPriceLabel from 'themes/common/components/ExtraPriceLabel'

import './LabelAnswer.scss'
import DescriptionButton from '../DescriptionButton'

export type LabelAnswerProps = CommonLabelAnswerProps & {
  price?: string | number
  currency: string
  lang?: string
  country?: string
  handleClick: (id: string) => void
  isOutOfStock?: boolean
  showRelativePrice?: boolean
}

const LabelAnswer = (props: LabelAnswerProps) => {
  const dispatch = useDispatch()

  const answerStyle = useThemeSettings('answer')
  const labelAnswerStyle = useThemeSettings('textInputAndDropdown')

  const handleSelectAnswer = (id: string) => {
    dispatch(setMobileDescription(null))
    props.handleClick(id)
  }

  return (
    <div
      className="answer-container label-answer--container"
      onClick={() => !props.disabled && handleSelectAnswer(props.id)}
    >
      <CommonLabelAnswer
        {...props}
        answerStyle={{ ...answerStyle, borderRadius: labelAnswerStyle.fieldBorderRadius }}
        isMultiAnswer={props.isMultiAnswer}
      />
      <ExtraPriceLabel
        extraClassNames="price-label__under-label"
        price={props.price}
        currency={props.currency}
        lang={props.lang}
        country={props.country}
        showRelativePrice={props.showRelativePrice}
      />
      {props.showDescription && (
        <DescriptionButton
          isVisible={false}
          onClick={() => dispatch(setMobileDescription(props))}
          className="description-button__label-answer"
        />
      )}
    </div>
  )
}

export default LabelAnswer
